<template>
  <div class="prospect-toolbar">
    <div class="flex gap-sm align-items-center flex-wrap">
      <div class="btn-group prospect-view-switcher segmented-control-stack-xs" role="group" aria-label="View">
        <button
          type="button"
          class="btn btn-default"
          :class="{ active: viewMode === 'queue' }"
          @click="$emit('update:viewMode', 'queue')"
        >
          Action Items
        </button>
        <button
          type="button"
          class="btn btn-default"
          :class="{ active: viewMode === 'all' }"
          @click="$emit('update:viewMode', 'all')"
        >
          Leads by Stage
        </button>
        <button
          type="button"
          class="btn btn-default"
          :class="{ active: viewMode === 'funnel' }"
          @click="$emit('update:viewMode', 'funnel')"
        >
          Cohort analysis
        </button>
      </div>

      <!-- Search + per-axis filters apply to the lead-list views only.
           The funnel report is an aggregate report with its own date picker,
           so showing these would be misleading. -->
      <template v-if="viewMode !== 'funnel'">
        <div class="flex-1" style="min-width: 200px; position: relative;">
          <input
            :value="searchQuery"
            type="search"
            class="form-control"
            placeholder="Search by parent, child, email, or phone..."
            @input="$emit('update:searchQuery', $event.target.value)"
          />
          <button
            v-if="searchQuery"
            type="button"
            class="btn btn-link"
            style="position: absolute; right: 4px; top: 50%; transform: translateY(-50%);"
            @click="$emit('update:searchQuery', '')"
          >
            <i class="fa-solid fa-xmark text-gray-500"></i>
          </button>
        </div>

        <select
          :value="activeStage"
          class="form-control"
          style="width: auto; display: inline-block;"
          @change="$emit('update:activeStage', $event.target.value)"
        >
          <option value="">All stages</option>
          <option v-for="opt in stageOptions" :key="opt.value" :value="opt.value">
            {{ opt.label }}
          </option>
        </select>

        <select
          :value="assignedFilter"
          class="form-control"
          style="width: auto; display: inline-block;"
          @change="$emit('update:assignedFilter', $event.target.value)"
        >
          <option value="me">My leads</option>
          <option value="">All coaches</option>
          <option v-for="coach in coachOptions" :key="coach.id" :value="String(coach.id)">
            {{ coach.full_name }}
          </option>
        </select>

        <button
          v-if="filterableQuestions.length > 0"
          type="button"
          class="btn btn-default"
          @click="showMore = !showMore"
        >
          <i class="fa-solid fa-sliders"></i> More
          <span v-if="filterQuestionId && filterAnswerValue" class="badge m-l-xxs">1</span>
        </button>
      </template>
    </div>

    <div v-if="viewMode !== 'funnel' && showMore && filterableQuestions.length > 0" class="flex align-items-center gap-x-sm m-t-sm flex-wrap">
      <label class="text-14 text-gray-600 m-b-none">Filter by answer:</label>
      <select
        :value="filterQuestionId"
        class="form-control input-sm"
        style="width: auto; display: inline-block;"
        @change="$emit('update:filterQuestionId', $event.target.value)"
      >
        <option value="">Select question...</option>
        <option v-for="q in filterableQuestions" :key="q.id" :value="q.id">{{ q.prompt }}</option>
      </select>
      <select
        v-if="filterQuestionId && filterAnswerOptions.length > 0"
        :value="filterAnswerValue"
        class="form-control input-sm"
        style="width: auto; display: inline-block;"
        @change="$emit('update:filterAnswerValue', $event.target.value)"
      >
        <option value="">Select answer...</option>
        <option v-for="opt in filterAnswerOptions" :key="opt" :value="opt">{{ opt }}</option>
      </select>
      <button
        v-if="filterQuestionId && filterAnswerValue"
        type="button"
        class="btn btn-xs btn-default"
        @click="$emit('clear-answer-filter')"
      >
        <i class="fa-solid fa-xmark"></i> Clear
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'prospect-toolbar',
  props: {
    viewMode: { type: String, default: 'queue' },
    searchQuery: { type: String, default: '' },
    activeStage: { type: String, default: '' },
    assignedFilter: { type: String, default: 'me' },
    filterQuestionId: { type: [String, Number], default: '' },
    filterAnswerValue: { type: String, default: '' },
    stageCounts: { type: Object, default: () => ({}) },
    coachOptions: { type: Array, default: () => [] },
    filterableQuestions: { type: Array, default: () => [] },
    filterAnswerOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      showMore: false,
    };
  },
  computed: {
    stageOptions() {
      return [
        { label: 'Interested', value: 'inquiry' },
        { label: 'Trial Scheduled', value: 'trial_scheduled' },
        { label: 'Trialing', value: 'trialing' },
        { label: 'Trial Complete', value: 'trial_complete' },
        { label: 'Converted', value: 'converted' },
        { label: "Didn't Join", value: 'didnt_join' },
        { label: 'Archived', value: 'archived' },
      ];
    },
  },
};
</script>
